module.exports = __webpack_public_path__ + "img/drive.2aea035f.svg";